import React from 'react';
import site from '../../data/site';
import Marquee from '../ui/Marquee';
import Icon from '../ui/Icon';
import Reveal from '../ui/Reveal';

// Only claims that appear on the company's own mark, plus plain descriptions
// of what the showroom does. Nothing here asserts an unverified certification.
const items = [
  { icon: 'seal', label: site.credential },
  { icon: 'gem', label: 'Gold & Diamond Jewellery' },
  { icon: 'crown', label: 'Gold Antique Jewellery' },
  { icon: 'tag', label: 'Branded Jewellery' },
  { icon: 'sparkle', label: 'In-Store Consultation' },
  { icon: 'pin', label: 'C G Road, Ahmedabad' },
];

/** Slim ticker of credentials between the hero and the catalogue. */
export function TrustStrip() {
  return (
    <Reveal variant="fade" duration={900} className="border-y border-ink-900/8 bg-ink-950 py-4">
      <Marquee speed="slow">
        {items.map((item, i) => (
          <span key={`${item.label}-${i}`} className="flex items-center">
            <span className="flex items-center gap-3 px-8">
              <Icon name={item.icon} size={16} className="text-sun-400" />
              <span className="whitespace-nowrap text-[0.7rem] uppercase tracking-mega text-canvas/70">
                {item.label}
              </span>
            </span>
            <span className="h-1 w-1 rounded-full bg-champagne-300/40" aria-hidden="true" />
          </span>
        ))}
      </Marquee>
    </Reveal>
  );
}

export default TrustStrip;
